<!--多选 MCQ-->
<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #EDEFF2',
    }"
  >
    <!-- 题 -->
    <div class="question-type">多选</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          <span v-if="isCountMust">
            {{ dataObj.caseProblem }}
            <span style="font-size: 14px; color: #979898">{{
              `(必须选${maxCount}项)`
            }}</span>
          </span>
          <span v-else-if="isCountSwitch">
            {{ dataObj.caseProblem }}
            <span style="font-size: 14px; color: #979898"
              >{{ `(最多选${maxCount}项，最少${minCount}项)` }}
            </span>
          </span>
          <span v-else>
            {{ dataObj.caseProblem }}
            <span style="font-size: 14px; color: #979898">{{
              `(最多选${maxCount}项)`
            }}</span>
          </span>
          <!-- (最少选${minCount}项) -->
        </span>
        <span
          style="
            position: relative;
            top: -2px;
            padding: 0 8px;
            line-height: 20px;
            background: rgba(58, 96, 255, 0.09);
            border: 1px solid rgba(58, 96, 255, 0.4);
            border-radius: 4px;
            font-size: 13px;
            font-weight: 500;
            text-align: center;
            color: #3a60ff;
            display: inline-block;
            margin-left: 10px;
          "
        >
          {{ dataObj.questionScore ? dataObj.questionScore : "0" }}分
        </span>
      </span>
    </div>
    <div v-for="(item, index) in list" :key="index">
      <div
        class="choose-css choose-css-new"
        :class="{ active: item.isChoose }"
        style="
          border: 1px solid rgba(237, 237, 237, 0.5);
          background: rgba(247, 247, 247, 1);
        "
        @click="handleChoose(item, index)"
      >
        <div class="choose-css-text">
          <p
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(43, 47, 54, 1);
            "
          >
            {{ item.text }}
          </p>
          <!-- <div v-if="rules.length > 0" style="margin-top: 10px">
            <div
              v-if="rules[index].action === 'jump'"
              style="font-size: 12px; color: #ff9900"
            >
              跳转到({{ rules[index].targets[0] }}、{{
                rules[index].problem
                  ? rules[index].problem.length > 10
                    ? rules[index].problem.slice(0, 10) + "..."
                    : rules[index].problem
                  : ""
              }})
            </div>
            <div
              v-else-if="this.rules[index].action === 'end'"
              style="font-size: 12px; color: #ff9900"
            >
              {{ "问卷结尾，结束答题" }}
            </div>
            <div v-else style="font-size: 9px; color: #ff9900"></div>
          </div> -->
          <div
            class="select-icon"
            style="
              border: 1px solid rgba(237, 237, 237, 1);
              background: #ffffff;
            "
          ></div>
        </div>
        <div class="question-images">
          <div
            class="question-images-box"
            @click.stop="showBigImage(imgItem, item)"
            v-for="(imgItem, imgIndex) in item.img_path"
            :key="imgIndex"
            style="margin-top: 10px; position: relative"
          >
            <img :src="imgItem" mode="aspectFill" class="thumbnail-image" />
            <div class="fangda-box">查看图片</div>
          </div>
        </div>
      </div>
      <div v-if="item.is_fill && item.isChoose" class="option-item-bottom">
        <div class="option-item-bottom-input">
          <input
            
            type="text"
            placeholder="编辑提示词"
            v-model="item.fill_prompt"
            @blur="handleBlur(item, index)"
          />
        </div>
      </div>
    </div>
    <div class="fangda-popup" v-if="fangdaShow" @click="fangdaClose">
      <div class="popup-content" @click.stop>
        <img
          src="@/assets/images/guanbi.png"
          class="popup-guanbi"
          @click="fangdaClose"
        />
        <div class="popup-scroll">
          <div>{{ fangdaTitle }}</div>
          <img :src="fangdaImgUrl" style="width: 100%" />
        </div>
      </div>
    </div>
    <!--        <div v-if="dataObj.status === 3 || dataObj.status === 4" class="vote-btn"-->
    <!--              :style="{backgroundImage: `linear-gradient(to right, rgba(${themeColor.r},${themeColor.g},${themeColor.b}), rgba(${themeColor.r},${themeColor.g},${themeColor.b}))`}"-->
    <!--              @click="handleAnswerClick">-->
    <!--            确认-->
    <!--        </div>-->
  </div>
</template>

<script>
export default {
  name: "EvaluationPreviewMCQ",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      answerObj: {},
      list: [],
      count: 0,
      startColor: {
        r: 58,
        g: 96,
        b: 255,
      },
      endColor: {
        r: 58,
        g: 96,
        b: 255,
      },
      themeColor: {
        r: 58,
        g: 96,
        b: 255,
      },
      images: [],
      index: 0,
      minCount: 1,
      maxCount: 1,
      isCountMust: false,
      isCountSwitch: false,
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      dataObj: {},
    };
  },
  watch: {
    params: {
      handler(newVal) {
        if (newVal) {
          this.dataObj = newVal.data;
          this.index = newVal.index;
          this.list = JSON.parse(newVal.data.chooseList).list;
          this.minCount = JSON.parse(newVal.data.chooseList).minCount;
          this.maxCount = JSON.parse(newVal.data.chooseList).maxCount;
          this.maxCount = JSON.parse(newVal.data.chooseList).maxCount;
          this.isCountMust = JSON.parse(newVal.data.chooseList).isCountMust;
          this.isCountSwitch = JSON.parse(newVal.data.chooseList).isCountSwitch;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleChoose(item, index) {
      if (this.dataObj.status === 3 || this.dataObj.status === 4) {
        return;
      }
      item.isChoose = !item.isChoose;
      this.count = this.list.filter((item) => item.isChoose).length;
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleBlur(item, index) {
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text;
    },
    fangdaClose() {
      this.fangdaShow = false;
    },
    handleAnswerClick() {
      if (this.count < this.minCount) {
        alert(`最少选择${this.minCount}项`);
        return;
      }
      if (this.count > this.maxCount) {
        alert(`最多选择${this.maxCount}项`);
        return;
      }
      this.$emit(
        "answer",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.question-container {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
}

// .question-type {
//   font-size: 14px;
//   font-weight: 500;
//   color: #3a60ff;
//   margin-bottom: 10px;
// }

.title-view {
  margin-bottom: 20px;
}

.asterisk {
  color: #ff4d4f;
  margin-right: 4px;
}

.option-item {
  margin-bottom: 15px;
}

.option-item-left {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}

.option-item-left-checkbox {
  margin-right: 10px;
  margin-top: 2px;
}

.option-checked {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkmark {
  color: white;
  font-size: 10px;
  font-weight: bold;
}

.option-item-content {
  flex: 1;
}

.option-text {
  font-size: 14px;
  color: #4c4a56;
  line-height: 20px;
}

.question-images-box {
  position: relative;
  display: inline-block;
  margin-right: 10px;
}

.thumbnail-image {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  object-fit: cover;
}

.fangda-box {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  padding: 4px;
  font-size: 12px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.option-item-bottom {
  margin-top: 10px;
  margin-left: 26px;
}

.option-item-bottom-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  box-sizing: border-box;
}

.input-placeholder {
  color: #999;
  width: 100%;
  border: none;
  outline: none;
}

.input-placeholder::placeholder {
  color: #999;
}

.fangda-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  background: white;
  border-radius: 8px;
  padding: 20px;
}

.popup-guanbi {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.popup-scroll {
  max-height: 80vh;
  overflow-y: auto;
}

.popup-scroll img {
  width: 100%;
  margin-top: 10px;
}

.vote-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  margin-top: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationPreview/EvaluationPreviewMCQ.vue